import React, { useState, useEffect } from 'react';
import { Statement } from '../../types/user';
import { fetchStatements } from '../../services/profileService';

export default function Statements() {
  const [statements, setStatements] = useState<Statement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStatements()
      .then(setStatements)
      .catch((err: any) => setError(err.message || 'Failed to load statements'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="profile-loading">Loading statements…</div>;
  if (error) return <div className="profile-error">{error}</div>;

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Statements</h3>
      {statements.length === 0 ? (
        <p className="profile-empty">No statements available.</p>
      ) : (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Period</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {statements.map(s => (
              <tr key={s.id}>
                <td>{s.period}</td>
                <td>{new Date(s.startDate).toLocaleDateString()}</td>
                <td>{new Date(s.endDate).toLocaleDateString()}</td>
                <td>
                  <a
                    href={s.downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="profile-link"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
